<style>
    .ivu-table .demo-table-info-row td{
        color: red;
    }

    .custom-group-switch {
        margin-right: -2px;
        z-index: 10;
        border-radius: 0;
    }
    .custom-group-switch .ivu-switch-large{
        height: 99%;
        border-radius: 0;
        padding-top: 4px;
        width: 70px;
    }
    .custom-group-switch .ivu-switch-inner{
        margin-left: 4px;
    }
    .custom-group-switch .ivu-switch-large:after{
        margin: 4px 0 0 4px;
    }
</style>

<template>
  <div>
    <Card>
        <p slot="title"> Giro Histori Pembatalan </p>
        <Row type="flex" justify="space-between">
            <Col span="6">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Terima Giro</Button>
                    <DatePicker
                        v-model="giroDateSelected"
                        type="daterange"
                        placeholder="Select date"
                        style="width: 180px"
                        @on-change="getReceivableGiroList()"/>
                </ButtonGroup>
            </Col>
            <Col span="6">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Jatuh Tempo</Button>
                    <DatePicker
                        v-model="paymentDateSelected"
                        type="daterange"
                        placeholder="Select date"
                        style="width: 180px"
                        @on-change="getReceivableGiroList()"/>
                </ButtonGroup>
            </Col>
            <Col span="5" style="display: flex;">
                <div class="custom-group-switch">
                    <i-switch size="large" v-model="isGroupFilter">
                        <span slot="open">Group</span>
                        <span slot="close">Mark</span>
                    </i-switch>
                </div>
                <transition name="move-right">
                    <Select
                        clearable
                        filterable
                        placeholder="Select Marking"
                        v-show="isGroupFilter == false"
                        v-model="markingHeaderIdSelected"
                        :remote-method="getMarkingByCode"
                        :loading="isLoadingGetMarking"
                        @on-change="getReceivableGiroList()">
                        <Option v-for="option in optionMarkings"
                            :value="option.value"
                            :key="option.value">{{option.label}}</Option>
                    </Select>
                </transition>

                <transition name="move-left">
                    <Select
                        clearable
                        filterable
                        placeholder="Select Group Name"
                        v-show="isGroupFilter == true"
                        v-model="markingGroupIdSelected"
                        :remote-method="getGroupMarkingByCode"
                        :loading="isLoadingGetMarking"
                        @on-change="getReceivableGiroList()">
                        <Option v-for="option in optionGroupMarkings"
                            :value="option.value"
                            :key="option.value">{{option.label}}</Option>
                    </Select>
                </transition>
            </Col>
            <Col span="6">
                <Spin size="large" v-show="isLoadingGiroList"></Spin>
            </Col>
        </Row>

        <br/>

        <Card>
            <Alert type="info" show-icon v-show="totalGiro != 0"> Total Giro = {{ totalGiro }} lembar</Alert>
            <Alert type="success" show-icon v-show="totalGiro != 0"> Total Nominal = Rp {{ totalNominal | numberFormatted }}</Alert>
            <Table :row-class-name="rowClassName" :columns="columnsDataTable" :data="receivableGiroData"></Table>
        </Card>
    </Card>

    <!-- Modal add giro -->
    <Modal v-model="isModalAddGiro" width="500px">
        <p slot="header" style="color:#2d8cf0;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Tambah Giro</span>
        </p>
        <Form ref="formAddGiro" :model="formAddGiro" :rules="ruleValidateGiro">
            <Form-item>
                <Row>
                    <Col span="12">
                        <i-switch size="large" v-model="isGroupAdd">
                            <span slot="open">Group</span>
                            <span slot="close">Mark</span>
                        </i-switch>
                    </Col>
                    <Col span="11" offset="1">
                        <transition name="move-up">
                            <Select
                                filterable
                                placeholder="Ketik Marking"
                                v-show="isGroupAdd == false"
                                v-model="formAddGiro.markingHeaderId"
                                :remote-method="getMarkingByCode"
                                :loading="isLoadingGetMarking"
                                @on-change="isForm = true" >
                                <Option v-for="option in optionMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </transition>

                        <transition name="move-down">
                            <Select
                                filterable
                                placeholder="Ketik Group Name"
                                v-show="isGroupAdd == true"
                                v-model="formAddGiro.markingGroupId"
                                :remote-method="getGroupMarkingByCode"
                                :loading="isLoadingGetMarking"
                                @on-change="isForm = true" >
                                <Option v-for="option in optionGroupMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </transition>
                    </Col>
                </Row>
            </Form-item>
            <div v-show="isForm">
                <Form-item label="Tanggal Terima Giro" prop="giroDate">
                    <Date-picker
                        placeholder="Tanggal Terima Giro"
                        style="width: 200px;display:revert;"
                        type="date"
                        format="yyyy-MM-dd"
                        v-model="formAddGiro.giroDate">
                    </Date-picker>
                </Form-item>
                <Form-item label="Nomor Giro" prop="giroNumber">
                    <Input v-model="formAddGiro.giroNumber" placeholder="Nomor Giro"></Input>
                </Form-item>
                <Form-item label="Nominal Giro" prop="giroNominal">
                    <!-- <Input v-model="formAddGiro.giroNominal" placeholder="Nominal Giro"></Input> -->
                    <br />
                    <money
                        v-model="formAddGiro.giroNominal"
                        v-bind="money"
                        class="ivu-input"></money>
                </Form-item>
                <Form-item label="Tanggal Jatuh Tempo" prop="paymentDate">
                    <Date-picker
                        placeholder="Tanggal Jatuh Tempo"
                        style="width: 200px;display:revert;"
                        type="date"
                        format="yyyy-MM-dd"
                        v-model="formAddGiro.paymentDate">
                    </Date-picker>
                </Form-item>
                 <!-- <Form-item label="Pending Payment" prop="pendingPaymentId">
                    <br>
                     <Select
                        filterable
                        placeholder="Ketik Payment Pending"
                        v-show="isGroup == false"
                        v-model="formAddGiro.paymentPendingId"
                        :remote-method="getPaymentPendingByFilter"
                        :loading="isLoadingGetMarking"
                        @on-change="isForm = true" >
                        <Option v-for="option in optionPendings"
                            :value="option.value"
                            :key="option.value">{{option.label}}</Option>
                    </Select>
                </Form-item> -->
                <Form-item label="Bank" prop="bankAccountId">
                    <br>
                    <Select
                        style="width:80%;display:revert"
                        placeholder="Pilih Rekening Bank"
                        clearable
                        filterable
                        v-model="formAddGiro.bankAccountId">
                        <Option
                            v-for="bankAccount in bankAccounts"
                            :value="bankAccount.id"
                            :key="bankAccount.id">{{ bankAccount.accountName }}
                        </Option>
                    </Select>
                </Form-item>
                <Form-item label="Upload File" prop="file">
                    <br>
                    <Input style="display: none;" v-model="formAddGiro.markingHeaderCode"></Input>
                    <Upload
                        type="drag"
                        ref="upload"
                        name="fileUploaded"
                        :action="this.serverUrlUploadFile"
                        :before-upload="handleBeforeUpload">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                </Form-item>
            </div>
        </Form>
        <div slot="footer">
            <Button
                v-show="true"
                type="primary"
                :loading="isLoadingAddGiro"
                @click="postAddGiro" >
                <span v-if="!isLoadingAddGiro">Submit</span>
                <span v-else>On process.....</span>
            </Button>
        </div>
    </Modal>

    <!-- Modal confirm update list -->
    <Modal v-model="isModalConfirm" title="Konfirmasi" @on-cancel="cancelUpdateGiroList">
        <p>{{ confirmationMessage }}</p>
        <br/>
        <div v-show="isNeedConfirm">
            <i> Tambah keterangan untuk melanjutkan ! (minimal 5 karakter)</i>
            <Input v-model="confirmDescription" placeholder="notes" />
        </div>

        <div slot="footer" v-if="isNeedConfirm">
            <Button type="primary" long @click="updateGiroList" v-show="confirmDescription.length >= 5">Ya</Button>
        </div>
        <div slot="footer" v-else>
            <Button type="text" @click="cancelUpdateGiroList">Tidak</Button>
            <Button type="primary" @click="updateGiroList">Ya</Button>
        </div>
    </Modal>

    <!-- Modal show history -->
    <Modal v-model="isModalHistory" title="History">
        <Table :columns="columnsHistory" :data="dataHistory"></Table>
    </Modal>

    <!-- Modal edit giro -->
    <Modal v-model="isModalEdit" width="500px">
        <p slot="header" style="color:#2cb7f5;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Edit Giro</span>
        </p>
        <Form ref="formEditGiro" :model="formEditGiro" :rules="ruleValidateGiro">
            <Form-item>
                <Row>
                    <Col span="6">
                        <i-switch size="large" v-model="isGroupEdit">
                            <span slot="open">Group</span>
                            <span slot="close">Mark</span>
                        </i-switch>
                    </Col>
                    <Col span="17" offset="1">
                        <transition name="move-up">
                            <Select
                                filterable
                                placeholder="Ketik Marking"
                                v-show="isGroupEdit == false"
                                v-model="formEditGiro.markingHeaderId"
                                :remote-method="getMarkingByCode"
                                :loading="isLoadingGetMarking">
                                <Option v-for="option in optionMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </transition>

                        <transition name="move-down">
                            <Select
                                filterable
                                placeholder="Ketik Group Name"
                                v-show="isGroupEdit == true"
                                v-model="formEditGiro.markingGroupId"
                                :remote-method="getGroupMarkingByCode"
                                :loading="isLoadingGetMarking">
                                <Option v-for="option in optionGroupMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </transition>
                    </Col>
                </Row>
            </Form-item>
            <Form-item label="Tanggal Terima Giro" prop="giroDate">
                <Date-picker
                    placeholder="Tanggal Terima Giro"
                    style="width: 200px;display:revert;"
                    type="date"
                    format="yyyy-MM-dd"
                    v-model="formEditGiro.giroDate">
                </Date-picker>
            </Form-item>
            <Form-item label="Nomor Giro" prop="giroNumber">
                <Input v-model="formEditGiro.giroId" style="display: none;"></Input>
                <Input v-model="formEditGiro.giroNumber" placeholder="Nomor Giro"></Input>
            </Form-item>
            <Form-item label="Nominal Giro" prop="giroNominal">
                <br />
                <money
                    v-model="formEditGiro.giroNominal"
                    v-bind="money"
                    class="ivu-input"></money>
            </Form-item>
            <Form-item label="Tanggal Jatuh Tempo" prop="paymentDate">
                <Date-picker
                    placeholder="Tanggal Jatuh Tempo"
                    style="width: 200px;display:revert;"
                    type="date"
                    format="yyyy-MM-dd"
                    v-model="formEditGiro.paymentDate">
                </Date-picker>
            </Form-item>
            <Form-item label="Bank" prop="bankAccountId">
                <br>
                <Select
                    style="width:80%;display:revert"
                    placeholder="Pilih Rekening Bank"
                    clearable
                    v-model="formEditGiro.bankAccountId">
                    <Option
                        v-for="bankAccount in bankAccounts"
                        :value="bankAccount.id"
                        :key="bankAccount.id">{{ bankAccount.accountName }}
                    </Option>
                </Select>
            </Form-item>
        </Form>
        <div slot="footer">
            <Button
                v-show="true"
                type="primary"
                :loading="isLoadingEditdGiro"
                @click="postUpdateGiro" >
                <span v-if="!isLoadingEditdGiro">Submit</span>
                <span v-else>On process.....</span>
            </Button>
        </div>
    </Modal>

    <!-- Modal delete payment -->
    <Modal v-model="isModalDelete" title="Konfirmasi" ok-text="Ya" cancel-text="Tidak" @on-cancel="confirmDescription = ''">
        <p>Apakah anda yakin ingin menghapus pembayaran giro?</p>
        <br/>
        <div>
            <i> Ketik <b>{{ formDeleteGiro.giroNumber }}</b> untuk melanjutkan !</i>
            <Input v-model="formDeleteGiro.giroId" style="display: none;"></Input>
            <Input v-model="formDeleteGiro.paymentId" style="display: none;"></Input>
            <Input v-model="confirmDescription" />
        </div>

        <div slot="footer">
            <Button type="error" long v-show="(formDeleteGiro.giroNumber).toUpperCase() == confirmDescription.toUpperCase()" @click="deleteGiroPayment">Hapus</Button>
        </div>
    </Modal>

    <!-- Generate PDF -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :pdf-quality="2"
      :manual-pagination="true"
      :html-to-pdf-options= this.htmlPdfOption
      pdf-content-width="100%"
      ref="html2Pdf"
      >
      <section slot="pdf-content">
<div class="container">
	<div class="table">
		<div class="table-header">
			<div class="header__item">Marking</div>
			<div class="header__item">Marking Group</div>
			<div class="header__item">Tgl. Terima Giro</div>
			<div class="header__item">Tgl. Jatuh Tempo</div>
			<div class="header__item">Nomor Giro</div>
			<div class="header__item">Nominal Giro</div>
			<div class="header__item bank-header">Bank</div>
			<div class="header__item">Tgl. Mundur</div>
			<div class="header__item">Kliring</div>
			<div class="header__item">Keterangan Tgl. Mundu</div>
			<div class="header__item">Keterangan Pembatalan</div>
		</div>
		<div class="table-content">
      <section class="pdf-item" v-for="(value, index) in receivableGiroData">

			<div class="table-row pdf-item" :class="{ 'html2pdf__page-break page-break': (index + 1) % 12 === 0 }">
				<div class="table-data">{{ value.marking }}</div>
				<div class="table-data">{{ value.markingGroup }}</div>
				<div class="table-data">{{ value.giroDate }}</div>
				<div class="table-data">{{ value.paymentDate }}</div>
				<div class="table-data">{{ value.giroNumber }}</div>
				<div class="table-data">{{ value.giroNominal }}</div>
				<div class="table-data bank-body">{{ value.accountName }}</div>
				<div class="table-data">{{ value.dueDate }}</div>
				<div class="table-data">{{ value.isClearing ? 'Ya' : 'Tidak' }}</div>
				<div class="table-data">{{ value.dueNotes }}</div>
				<div class="table-data">{{ value.cancelNotes }}</div>
			</div>

      <div class="table-header" v-if="(index + 1) % 12 === 0 && receivableGiroData.length !== index+1">
			<div class="header__item">Marking</div>
			<div class="header__item">Marking Group</div>
			<div class="header__item">Tgl. Terima Giro</div>
			<div class="header__item">Tgl. Jatuh Tempo</div>
			<div class="header__item">Nomor Giro</div>
			<div class="header__item">Nominal Giro</div>
			<div class="header__item bank-header">Bank</div>
			<div class="header__item">Tgl. Mundur</div>
			<div class="header__item">Kliring</div>
			<div class="header__item">Keterangan Tgl. Mundu</div>
			<div class="header__item">Keterangan Pembatalan</div>
		</div>

    </section>
		</div>
	</div>
</div>
          </section>
        </vue-html2pdf>


  </div>
</template>

<style>
:root {
  --color-alpha: #1772FF;
  --color-form-highlight: #495060;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.container {
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-color: white;
}

.page-break {
margin-bottom: 10px;
}

.table {
  width: 100%;
}

.table-header {
  display: flex;
  width: 100%;

  .bank-header{
    flex: 1 1 40%;
  }
}

.table-row {
  display: flex;
  width: 100%;

  .bank-body {
    flex: 1 1 40%;
  }
}

.table-data,
.header__item {
  flex: 1 1 20%;
  text-align: center;
  border: 0.5px solid var(--color-form-highlight);
}

.header__item {
  text-transform: uppercase;
  line-height: 200%;
  font-weight: 500;
}

</style>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import {Money} from 'v-money'
import VueHtml2pdf from 'vue-html2pdf'
import * as XLSX from 'xlsx'

const numeral = require('numeral');

export default {
    components : {
      Money,
      VueHtml2pdf
    },
    data () {
        return {
            money: {
              decimal: ',',
              thousands: '.',
              prefix: '',
              suffix: '',
              precision: 0,
              masked: false
            },
            giroDateSelected : [],
            paymentDateSelected : [],
            markingGroupIdSelected : null,
            markingHeaderIdSelected : null,
            isGroupFilter: false,
            isLoadingGiroList: false,
            columnsDataTable: [
                {
                    title: 'Marking',
                    key: 'marking',
                    width: 150,
                },
                {
                    title: 'Marking Grup',
                    key: 'markingGroup',
                    width: 150,
                },
                {
                    title: 'Tgl. Terima Giro',
                    key: 'giroDate',
                    width: 150,
                },
                {
                    title: 'Tgl. Jatuh Tempo',
                    key: 'paymentDate',
                    width: 150,
                },
                {
                    title: 'Nomor Giro',
                    key: 'giroNumber',
                    width: 200,
                },
                {
                    title: 'Nominal Giro',
                    key: 'giroNominal',
                    width: 150,
                },
                {
                    title: 'Bank',
                    key: 'accountName',
                    width: 300,
                },
                {
                    title: 'File',
                    key: 'file',
                    align: 'center',
                    width: 250,
                    render: (h, params) => {
                        const { row } = params

                        return h('div', [
                            h('a', {
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.downloadFile(row.markingHeaderCode, row.file)
                                    }
                                }
                            }, row.file)
                        ]);
                    }
                },
                {
                    title: 'Tgl. Mundur',
                    key: 'dueDate',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let setDisable = row.isCancel == 1 ? true : false

                        return h('DatePicker', {
                            props: {
                                type: 'date',
                                value: row.dueDate,
                                disabled: setDisable
                            },
                            on: {
                                'on-change': (date) => {
                                    setDisable ? false : this.showModalConfirm('isDueDate', date, params.index)
                                }
                            }
                        });
                    }
                },
                {
                    title: 'Kliring',
                    key: 'isClearing',
                    width: 80,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let setVal = row.isClearing == 1 ? true : false
                        let setDisable = row.isCancel == 1 ? true : false

                        return h('Checkbox', {
                            props: {
                                value: setVal,
                                checked: setVal,
                                disabled: setDisable
                            },
                            on: {
                                'on-change': (isClearing) => {
                                    this.showModalConfirm('isClearing', isClearing, params.index)
                                }
                            }
                        });
                    }
                },
                {
                    title: 'Keterangan Tgl. Mundur',
                    key: 'dueNotes',
                    width: 200,
                },
                {
                    title: 'Keterangan Pembatalan',
                    key: 'cancelNotes',
                    width: 200,
                }
            ],
            receivableGiroData: [],
            isModalConfirm: false,
            isNeedConfirm: false,
            confirmDescription: '',
            confirmationMessage: null,
            varType: null,
            varValue: null,
            varIndex: null,
            isModalHistory: false,
            columnsHistory: [
                {
                    title: 'Pembuat',
                    key: 'createdBy',
                },
                {
                    title: 'Tanggal Ubah',
                    key: 'createdAt',
                },
                {
                    title: 'Tanggal Jatuh Tempo',
                    key: 'dueDate',
                },
                {
                    title: 'Keterangan',
                    key: 'notes',
                },
            ],
            dataHistory: [],

            isModalAddGiro: false,
            optionMarkings : [],
            optionGroupMarkings : [],
            optionPendings : [],
            isLoadingGetMarking: false,
            isForm: false,
            isGroupAdd: false,
            formAddGiro: {
                markingHeaderId: null,
                markingGroupId: null,
                giroDate: '',
                giroNumber: '',
                giroNominal: '',
                paymentDate: '',
                bankAccountId: '',
                giroId: '',
                markingHeaderCode: ''
            },
            ruleValidateGiro: {
                giroDate: [
                    { required: true, type: 'date', message: 'Pilih Tanggal Terima Giro', trigger: 'change' }
                ],
                giroNumber: [
                    { required: true, message: 'Masukkan Nomor Giro', trigger: 'blur' }
                ],
                giroNominal: [
                    { required: true, message: 'Masukkan Nominal Giro', trigger: 'blur' }
                ],
                paymentDate: [
                    { required: true, type: 'date', message: 'Pilih Tanggal Jatuh Tempo', trigger: 'change' }
                ],
                // bankAccountId: [
                //     { required: true, message: 'Pilih Bank', trigger: 'change' }
                // ]
            },
            bankAccounts: [],
            isLoadingAddGiro: false,
            serverUrlUploadFile: "",
            isProgress: false,
            pValue: 0,

            isModalEdit: false,
            isGroupEdit: false,
            formEditGiro: {
                markingHeaderId: null,
                markingGroupId: null,
                giroDate: '',
                giroNumber: '',
                giroNominal: '',
                paymentDate: '',
                bankAccountId: '',
            },
            isLoadingEditdGiro: false,

            isModalDelete: false,
            formDeleteGiro: {
                giroId: null,
                paymentId: null,
                giroNumber: ''
            },
            filename: `giro-list-` + Date.now(),
            htmlPdfOption: {
              filename: `giro-list-` + Date.now() +`.pdf`,
              margin: 5,
              jsPDF: {
                format: 'a4',
                orientation: 'l'
              }
            },

            totalGiro: 0,
            totalNominal: 0
        }
    },
    methods: {
        rowClassName (row, index) {
            if (row.isCancel) {
                return 'demo-table-info-row';
            }

            return '';
        },
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getReceivableGiroList: function(){
            let parent = this;
            let startGiroDate = null;
            let endGiroDate = null;
            let startPaymentDate = null;
            let endPaymentDate = null;

            // set is group & null marking
            if (this.isGroupFilter) {
                this.markingHeaderIdSelected = null;
            }
            // set is marking & null group marking
            else {
                this.markingGroupIdSelected = null;
            }

            // handle giro date - tanggal terima giro
            if(this.giroDateSelected[0] != "" && this.giroDateSelected[0] != null) {
                startGiroDate = moment(this.giroDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endGiroDate = moment(this.giroDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            // handle payment date / tanggal jatuh tempo
            if(this.paymentDateSelected[0] != "" && this.paymentDateSelected[0] != null) {
                startPaymentDate = moment(this.paymentDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endPaymentDate = moment(this.paymentDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            let payload = {
                startGiroDate: startGiroDate,
                endGiroDate: endGiroDate,
                startPaymentDate: startPaymentDate,
                endPaymentDate: endPaymentDate,
                markingHeaderId: this.markingHeaderIdSelected,
                markingGroupId: this.markingGroupIdSelected,
                isCancel: true
            }
            console.log({payload});

            this.isLoadingGiroList = true;
            HTTP.post('giro/search', payload)
            .then(response => {
                let receivableGiro = []
                console.log({response});
                // reset calculate total giro & total nominal
                parent.totalGiro = 0
                parent.totalNominal = 0

                _.forEach(response.data, function(value, index) {
                    let receivableId = value.creditReceivableId
                    let paymentId = value.paymentId
                    let giroId = value.id
                    let giroDate = parent.showDateFormatted(value.giroDate)
                    let giroNumber = value.giroNumber
                    let giroNominal = "Rp. " + numeral(value.giroNominal).format('0,0')
                    let paymentDate = parent.showDateFormatted(value.paymentDate)
                    let bankAccountId = value.bank_account != null ? value.bank_account.id : ''
                    let accountName = value.bank_account != null ? value.bank_account.accountName : ''
                    // let dueDate = parent.showDateFormatted(value.dueDate)
                    let dueDate = moment(value.dueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD")
                    let isClearing = value.isClearing
                    let isCancel = value.isCancel
                    let giroHistory = value.giro_history
                    let description = value.receivable != null ? value.receivable.description : ''
                    let partai = value.receivable != null ? value.receivable.invoice.packaging_list.container_loading.containercode : ''
                    let marking = value.marking_header != null ? value.marking_header.markingheadercode : '-'
                    let markingHeaderId = value.marking_header != null ? value.marking_header.markingheaderid : null
                    let markingGroup = value.marking_group != null ? value.marking_group.code : '-'
                    let markingGroupId = value.marking_group != null ? value.marking_group.id : null
                    let dueNotes = value.dueNotes
                    let cancelNotes = value.cancelNotes
                    let file = value.filename
                    let markingHeaderCode = null

                    if (value.marking_header != null) {
                        markingHeaderCode = value.marking_header.markingheadercode
                    } else if (value.marking_group != null) {
                        markingHeaderCode = value.marking_group.code
                    }


                    let paymentAllocate = [{
                        invoicefee : value.receivable != null ? value.receivable.invoice.invoicefee : '',
                        invoiceDueId : value.invoice_due != null ? value.invoice_due.id : '',
                        allocateAmount : value.giroNominal,
                        receivableRemaining : value.invoice_due != null ? value.invoice_due.receivableRemaining : '',
                        useDepositAmount : 0,
                    }]

                    let clearingPaymentAdd = {
                        markingHeaderId: value.markingHeaderId,
                        amount : value.giroNominal,
                        transactionDate : moment(value.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                        description : 'KU ' + accountName + ' P. ' + partai + ' - ' + description,
                        accountNumber : value.bank_account != null ? value.bank_account.id : '',
                        depositAmount : 0,
                        paymentAllocates : paymentAllocate,
                        depositType: '',
                        category: 'pay',
                        // paymentPendingId: null,
                        giroId : giroId
                    }

                    let rGiro = {
                        markingHeaderId : markingHeaderId,
                        markingGroupId : markingGroupId,
                        marking : marking,
                        markingGroup : markingGroup,
                        markingHeaderCode : markingHeaderCode,
                        receivableId : receivableId,
                        paymentId : paymentId,
                        giroId : giroId,
                        giroDate : giroDate,
                        giroNumber : giroNumber,
                        giroNominal: giroNominal,
                        paymentDate: paymentDate,
                        bankAccountId: bankAccountId,
                        accountName: accountName,
                        dueDate: dueDate,
                        isClearing: isClearing,
                        isCancel: isCancel,
                        giroHistory: giroHistory,
                        clearingPaymentAdd: clearingPaymentAdd,
                        dueNotes: dueNotes,
                        cancelNotes: cancelNotes,
                        file: file
                    }
                    receivableGiro.push(rGiro);

                    // calculate total giro & total nominal
                    parent.totalGiro++
                    parent.totalNominal += value.giroNominal
                });

                console.log({receivableGiro});

                this.receivableGiroData = receivableGiro;
                this.isLoadingGiroList = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },
        downloadFile: function(markingHeaderCode, fileName) {
            let payload = {
                markingHeaderCode : markingHeaderCode,
                filename : fileName
            }

            console.log({payload});
            HTTP
            .post('giro/file/download', payload, { responseType: 'blob' })
            .then(response => {
                console.log({response});
                let a = document.createElement("a");
                let url = window.URL.createObjectURL(response.data);

                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd == false || this.isGroupFilter == false)) {
                    this.isLoadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.searchSelectSubbranch || null
                    })
                    .then(response => {
                        this.isLoadingGetMarking = false;
                        let data = response.data;

                        if (data.length > 0) {
                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.formAddGiro.markingHeaderCode = list[0].label;
                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        }
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getEditMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '') {
                    this.formEditGiro.markingHeaderId = this.formEditGiro.markingSelectedId
                    this.isLoadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.searchSelectSubbranch || null,
                    })
                    .then(response => {
                        this.isLoadingGetMarking = false;
                        let data = response.data;

                        if (data.length > 0) {
                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        }
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getPaymentPendingByFilter: _.debounce(
          function(query){
            if (query && query !== '' && query.length >= 2) {
              this.optionPendings = []
              this.loadingSearch = true;

              let urlFindByFilter = 'paymentPending/findByFilter';

              HTTP
              .post(urlFindByFilter, {
                notes : query
              })
              .then(response => {
                  let data = response.data;

                  const list = data.map(item => {
                      return {
                          value: item.id,
                          label: item.transactionDate + ', ' + item.notes + ' - ' + "Rp. " + numeral(item.balance).format('0,0')
                      };
                  });

                  this.optionPendings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);


                  this.loadingSearch = false;
              })
              .catch(e => {
                  this.loadingSearch = false;
                  this.$Notice.error({
                      title: "Error",
                      desc: e,
                      duration: 5
                  });
              })
            }
        }),
        getGroupMarkingByCode:  _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd || this.isGroupFilter)) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('markingGroup/getByCode', {
                        groupName: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        if (data.length > 0) {
                            const list = data.map(item => {
                                return {
                                    value: item.id,
                                    label: item.code
                                };
                            });

                            this.formAddGiro.markingHeaderCode = list[0].label;
                            this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        }
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        getEditGroupMarkingByCode:  _.debounce(
            function (query) {
                if (query && query !== '') {
                    this.formEditGiro.markingGroupId = this.formEditGiro.markingGroupSelectedId
                    this.loadingGetMarking = true;
                    HTTP
                    .post('markingGroup/getByCode', {
                        groupName: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        if (data.length > 0) {
                            const list = data.map(item => {
                                return {
                                    value: item.id,
                                    label: item.code
                                };
                            });

                            this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        }
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),

        getBankAccount: function() {
            HTTP.get("bankAccount/findAll/active")
            .then(response => {
                this.bankAccounts = response.data;
            })
            .catch(e => {
                this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
                });
            });
        },
        showAddGiro: function(){
            this.isModalAddGiro = true;
        },
        handleBeforeUpload (file) {
            console.log({file});

            const formData = new FormData();
            formData.append('file', file);
            formData.append('markingHeaderCode', this.formAddGiro.markingHeaderCode);

            this.isProgress = true;
            this.pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

            HTTP
            .post('/giro/file/upload', formData, {
               headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
                console.log("giro upload response :", response);
                this.formAddGiro.filename = response.data.filename; // Set filename
                // this.isProgress = false;
                this.pValue = 100;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },
        postAddGiro: function(){
            this.isLoadingAddGiro = true;
            this.$Loading.start();

            let payload = {
                markingHeaderId: this.formAddGiro.markingHeaderId,
                markingGroupId: this.formAddGiro.markingGroupId,
                giroDate: this.summaryDate = moment(this.formAddGiro.giroDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                giroNumber: this.formAddGiro.giroNumber,
                giroNominal: this.formAddGiro.giroNominal,
                paymentDate: moment(this.formAddGiro.paymentDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                // paymentPendingId: this.formAddGiro.paymentPendingId,
                bankAccountId: this.formAddGiro.bankAccountId,
                filename: this.formAddGiro.filename
            }
            console.log({payload});

            HTTP
            .post('giro/create', payload)
            .then(response => {
                console.log("post response :", response);

                this.isModalAddGiro = false;
                this.isLoadingAddGiro = false;
                this.$Loading.finish();
                this.$Message.success('Giro berhasil ditambahkan !');

                this.getReceivableGiroList(); // update list
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        },
        showModalConfirm: function(type, value, index){
            this.isModalConfirm = true
            this.varType = type
            this.varValue = value
            this.varIndex = index

            if (type == 'isDueDate') {
                this.confirmationMessage = 'Apakah anda yakin ingin mengubah tanggal mundur?'
                this.isNeedConfirm = true
            } else if (type == 'isClearing') {
                this.confirmationMessage = 'Apakah anda yakin ingin meng-kliring giro ?'
            } else if (type == 'isCancel') {
                this.confirmationMessage = 'Apakah anda yakin ingin membatalkan giro ?'
                this.isNeedConfirm = true
            } else {
                return false
            }
        },
        updateGiroList: function(){
            this.$Loading.start();

            let rowData = this.receivableGiroData[this.varIndex]
            let tempIsDueDate = ''
            let tempIsClearing = ''
            let tempIsCancel = ''
            let successMsg = ''
            let dueNotes = rowData.dueNotes
            let cancelNotes = rowData.cancelNotes

            console.log({rowData});
            // return false

            if (this.varType == 'isDueDate') {
                tempIsDueDate = this.varValue
                tempIsClearing = rowData.isClearing
                tempIsCancel = rowData.isCancel
                dueNotes = this.confirmDescription
                successMsg = 'Tanggal mundur berhasil diperbaharui !'
            } else if (this.varType == 'isClearing') {
                // Checklist = add payment
                // Unchecklist = delete payment
                // Update pembayaran terlebih dahulu
                // if (this.varValue) {
                //     HTTP
                //     .post('payment/pay', rowData.clearingPaymentAdd)
                //     .then(response => {
                //         this.$Message.success({
                //             content: 'Pembayaran telah ditambahkan !',
                //             duration: 2
                //         });
                //     })
                //     .catch(e => {
                //         this.$Notice.error({
                //             title: "Error",
                //             desc: e,
                //             duration: 5
                //         });

                //         return false
                //     })
                // } else {
                //     HTTP
                //     .post('payment/delete', {
                //         paymentId: rowData.paymentId,
                //         receivableId: rowData.receivableId
                //     })
                //     .then(response => {
                //         this.$Message.success({
                //             content: 'Pembayaran telah dihapus !',
                //             duration: 2
                //         });
                //     })
                //     .catch(e => {
                //         this.$Notice.error({
                //             title: "Error",
                //             desc: e,
                //             duration: 5
                //         });

                //         return false
                //     })
                // }

                tempIsDueDate = rowData.dueDate
                tempIsClearing = this.varValue
                tempIsCancel = rowData.isCancel
                successMsg = 'Giro berhasil dikliring !'
            } else if (this.varType == 'isCancel') {
                tempIsDueDate = rowData.dueDate
                tempIsClearing = rowData.isClearing
                tempIsCancel = this.varValue
                cancelNotes = this.confirmDescription
                successMsg = 'Giro berhasil dibatalkan !'
            } else {
                return false
            }

            let payload = {
                giroId: rowData.giroId,
                dueDate: moment(tempIsDueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                isClearing: tempIsClearing,
                isCancel: tempIsCancel,
                dueNotes: dueNotes,
                cancelNotes: cancelNotes
            }

            console.log({payload});

            HTTP
            .post('giro/update', payload)
            .then(response => {
                this.confirmDescription = '';
                this.isModalConfirm = false;
                this.isNeedConfirm = false;
                this.$Loading.finish();
                this.$Message.success(successMsg);
                this.getReceivableGiroList(this.paymentDateSelected);
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        },
        cancelUpdateGiroList: function() {
            this.getReceivableGiroList(this.paymentDateSelected);
            this.confirmDescription = '';
            this.isModalConfirm = false;
            this.isNeedConfirm = false;
        },
        showModalHistory: function(index){
            this.isModalHistory = true
            let parent = this
            let rowData = this.receivableGiroData[index]
            let histories = []

            _.forEach(rowData.giroHistory, function(value, index) {
                let createdBy = value.createdBy
                let createdAt = value.createdAt
                let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : '-'
                let notes = value.notes

                let history = {
                    createdBy : createdBy,
                    createdAt : createdAt,
                    dueDate : dueDate,
                    notes : notes,
                }
                histories.push(history);
            });

            this.dataHistory = histories;
        },
        showModalEdit: function(index){
            let rowData = this.receivableGiroData[index];

            console.log({rowData});
            if (rowData.markingHeaderId) {
                this.getEditMarkingByCode(rowData.marking)
            }

            if (rowData.markingGroupId) {
                this.isGroupEdit = true
                this.getEditGroupMarkingByCode(rowData.markingGroup)
            }

            this.formEditGiro.giroId = rowData.giroId;
            this.formEditGiro.markingSelectedId = rowData.markingHeaderId;
            this.formEditGiro.markingGroupSelectedId = rowData.markingGroupId;

            this.formEditGiro.markingHeaderId = rowData.markingHeaderId;
            this.formEditGiro.markingGroupId = rowData.markingGroupId;
            this.formEditGiro.giroDate = moment(rowData.giroDate, "DD MMM YYYY").format("YYYY-MM-DD");
            this.formEditGiro.giroNumber = rowData.giroNumber;
            this.formEditGiro.giroNominal = rowData.giroNominal;
            this.formEditGiro.paymentDate = moment(rowData.paymentDate, "DD MMM YYYY").format("YYYY-MM-DD");
            this.formEditGiro.bankAccountId = rowData.bankAccountId;

            this.isModalEdit = true;
        },
        postUpdateGiro: function(){
            this.isLoadingAddGiro = true;
            this.$Loading.start();

            let payload = {
                giroId: this.formEditGiro.giroId,
                markingHeaderId: this.formEditGiro.markingHeaderId,
                markingGroupId: this.formEditGiro.markingGroupId,
                giroDate: moment(this.formEditGiro.giroDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                giroNumber: this.formEditGiro.giroNumber,
                giroNominal: this.formEditGiro.giroNominal,
                paymentDate: moment(this.formEditGiro.paymentDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                bankAccountId: this.formEditGiro.bankAccountId
            }

            console.log({payload});
            // return false;

            HTTP
            .post('giro/update', payload)
            .then(response => {
                console.log("post update response :", response);

                this.isModalEdit = false;
                this.isLoadingAddGiro = false;
                this.$Loading.finish();
                this.$Message.success('Giro berhasil diubah !');
                this.getReceivableGiroList(this.paymentDateSelected);
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        },
        showModalDelete: function(index){
            let rowData = this.receivableGiroData[index];

            console.log({rowData});

            this.formDeleteGiro.giroId = rowData.giroId;
            this.formDeleteGiro.paymentId = rowData.paymentId;
            this.formDeleteGiro.giroNumber = rowData.giroNumber;

            this.isModalDelete = true;
        },
        deleteGiroPayment: function(){
            this.$Loading.start();

            let payload = {
                giroId: this.formDeleteGiro.giroId,
                paymentId: this.formDeleteGiro.paymentId,
            }

            console.log({payload});

            HTTP
            .post('giro/payment/delete', payload)
            .then(response => {
                console.log("post delete response :", response);

                if (response.data.data == true) {
                    this.isModalDelete = false;
                    this.$Loading.finish();
                    this.$Message.success('Pembayaran giro berhasil dihapus !');
                } else {
                    this.isModalDelete = false;
                    this.$Loading.finish();
                    this.$Message.error('Pembayaran giro gagal dihapus !');
                }

                this.getReceivableGiroList();
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        },

        generateReport () {
             this.$refs.html2Pdf.generatePdf()
         },

         generateExcel : function() {
          var listGiroData = _.map(this.receivableGiroData, obj => _.pick(obj, ['marking','markingGroup','giroDate','paymentDate','giroNumber','giroNominal','accountName','dueDate','isClearing','dueNotes','cancelNotes']))
        const data = XLSX.utils.json_to_sheet(listGiroData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'List giro')

        XLSX.utils.sheet_add_aoa(data, [['Marking', 'Marking Group', 'Tgl. Terima Giro', 'Tgl. Jatuh Tempo', 'Nomor Giro', 'Nomor Giro', 'Bank', 'Tgl. Mundur', 'Kliring', 'Keterangan Tgl. Mundur', 'Keterangan Pembatalan']])

        XLSX.writeFile(wb, this.filename + '.xlsx')
      }
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    mounted() {
        this.getReceivableGiroList()
        this.$Loading.config({
            color: '#fff',
            failedColor: '#f0ad4e',
            height: 10
        });

        this.getBankAccount();
    }
}

</script>



// WEBPACK FOOTER //
// GiroCancelledHistory.vue?3e3261ea